import { AfterViewInit, Directive, EventEmitter, HostListener, Input, OnDestroy, Output } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, tap } from 'rxjs/operators';
import { DebounceConstants } from './debounce-constants';

@Directive({
   selector: '[debouncedInput]',
})
export class DebouncedInputDirective implements OnDestroy, AfterViewInit {
   @Output()
   public debouncedInput: EventEmitter<any> = new EventEmitter<any>();

   @Input()
   public debouncedInputDelay = DebounceConstants.DEFAULT_DEBOUNCE;

   private stream: Subject<any> = new Subject<any>();
   private subscription: Subscription;

   constructor() {}

   ngOnDestroy(): void {
      this.subscription?.unsubscribe();
   }

   @HostListener('input', ['$event'])
   public onValueChange(value: any): void {
      this.stream.next(value);
   }

   ngAfterViewInit(): void {
      this.subscription = this.stream
         .pipe(
            debounceTime(this.debouncedInputDelay),
            tap((value: any) => this.debouncedInput.next(value))
         )
         .subscribe();
   }
}
